import Configs from "../config";
import { Api } from "../generated/Api";

export const api = new Api({
  baseUrl: Configs.SERVER_URL,
});
